import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import withFooterLocations from 'shared/hocs/withFooterLocations';
import Link from 'shared/components/Link/Link';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import s from './ColumnList.css';

class ColumnList extends React.Component {
  static propTypes = {
    list: PropTypes.arrayOf(
      PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          slug: PropTypes.string.isRequired,
          id: PropTypes.number.isRequired,
        }),
      ),
    ),
    updateUrl: PropTypes.func.isRequired,
    className: PropTypes.string.isRequired,
    titleKey: PropTypes.string,
    search: PropTypes.bool,
    isRegion: PropTypes.bool,
    resetHeader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    selectedLocation: PropTypes.shape(),
  };

  static defaultProps = {
    list: [],
    className: '',
    titleKey: 'title',
    locationLinkBuilder: null,
    routeName: null,
    resetHeader: null,
    search: false,
    isRegion: false,
    selectedLocation: undefined,
  };

  buildBreadCrumbs = (selectedLocation, titleKey) => {
    if (selectedLocation.is_admin_center) {
      const region = selectedLocation.parents.find(item => item.is_region);
      return (
        <React.Fragment>
          <Link
            to={this.props.updateUrl(region)}
            className={cx(s.resetLocationLink, s.curentBreadCrumbs, s.cursorPointer)}
          >
            <span className={s.hideHover}>&#62; </span>
            {region[titleKey]}
          </Link>
          <span className={cx(s.resetLocationLink, s.curentBreadCrumbs)}>
            <span>&#62; </span>
            {selectedLocation[titleKey]}
          </span>
        </React.Fragment>
      );
    }
    return (
      <span className={cx(s.resetLocationLink, s.curentBreadCrumbs)}>
        &#62; {selectedLocation[titleKey]}
      </span>
    );
  };

  render() {
    const {
      list,
      className,
      resetHeader,
      updateUrl,
      search,
      selectedLocation,
      isRegion,
      titleKey,
    } = this.props;

    return (
      <div className={!isRegion ? s.root : ''}>
        <div className={s.breadCrumbsBlock}>
          {search
            ? <div className={s.resetLocationText}>
                {resetHeader}
              </div>
            : isRegion &&
              <React.Fragment>
                <Link to={updateUrl(null)} className={s.resetLocationLink}>
                  {resetHeader}
                </Link>
                {selectedLocation && this.buildBreadCrumbs(selectedLocation, titleKey)}
              </React.Fragment>}
        </div>

        <div className={className}>
          {list.map(columnItems =>
            <ul className={s.column} key={columnItems[0].id}>
              {columnItems.map(columnItem => {
                if ((columnItem.disabled || columnItem.selectedLocation) && !search) {
                  return (
                    <p
                      key={columnItem.id}
                      className={cx(s.disabledCity, {
                        [s.selLocation]: columnItem.selectedLocation,
                      })}
                    >
                      {columnItem[titleKey]}
                    </p>
                  );
                }
                return (
                  <li className={s.item} key={`${columnItem.id}-link`}>
                    <Link
                      to={search ? updateUrl(null, columnItem.url) : updateUrl(columnItem)}
                      className={s.link}
                      title={columnItem.hint}
                    >
                      {columnItem[titleKey]}
                    </Link>
                  </li>
                );
              })}
            </ul>,
          )}
        </div>
      </div>
    );
  }
}

export default withFooterLocations(withStyles(s)(injectIntl(ColumnList)));



// WEBPACK FOOTER //
// ./src/desktop/components/Footer/ColumnList/ColumnList.js